import request from "../utils/fetch";
// 角色列表
export function staffRoleList(data) {
  return request({
    url: "/user/companyUserRole/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 角色新增或修改
export function staffRoleCao(data) {
  return request({
    url: "/user/companyUserRole/addOrUpdate",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 角色删除
export function staffRoleDel(data) {
  return request({
    url: "/user/companyUserRole/del",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 角色详情
export function staffRoleDetail(data) {
  return request({
    url: "/user/companyUserRole/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 角色下拉
export function staffRolePull(data) {
  return request({
    url: "/user/companyUserRole/pull/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//员工分区列表
export function fenList(data) {
  return request({
    url: "/user/afterSales/company/region/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//员工分区新增
export function fenAdd(data) {
  return request({
    url: "/user/afterSales/company/region/add",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//员工分区解绑
export function fenUnBind(data) {
  return request({
    url: "/user/afterSales/company/region/del",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//员工分区解绑
export function fenQian(data) {
  return request({
    url: "/user/afterSales/company/region/move",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 员工下拉最新
export function userPullNewClass(data) {
  return request({
    url: "/user/afterSales/user/move/pullList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 员工下拉最新
export function userPullNewClassTwo(data) {
  return request({
    url: "/user/afterSales/user/move/pullList/byRole",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
